import React, { useState } from "react";
import styles from "../styles/CheckOut.module.css";
import { Link } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";

const initState = {
  name: "",
  country: "",
  mobile_no: "",
  city: "",
  pin: "",
  state: "",
};

export default function SignUp() {
  const navigate = useNavigate();
  const [signupform, setSignupForm] = useState(initState);

  const handleclick = async (e) => {
    e.preventDefault();
    if (name === "" || city === "" || mobile_no === "") {
      alert("please fill all the neccessory fields");
    } else {
      alert("Payment Successfull");
      setTimeout(() => {
        navigate("/");
      }, 1000);
    }
  };

  const handleChange = (e) => {
    setSignupForm({ ...signupform, [e.target.name]: e.target.value });
  };

  const { name, email, mobile_no, city, pin, password } = signupform;

  return (
    <>
      <div className={styles.signup_empty}></div>
      <div className={styles.signup_main}>
        <div className={styles.form_cont}>
          <form>
            <label>
              Full Name <span className={styles.mandetory_fileds}>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={handleChange}
              placeholder="Enter your full name"
            />

            <label>
              Mobile Number <span className={styles.mandetory_fileds}>*</span>
            </label>
            <input
              type="number"
              name="mobile_no"
              value={mobile_no}
              onChange={handleChange}
              placeholder="Enter your Mobile Number"
            />
            <label>
              Address <span className={styles.mandetory_fileds}>*</span>
            </label>
            <label>
              Line1 <span className={styles.mandetory_fileds}>*</span>
            </label>
            <div className={styles.address_cont}>
              <input
                type="text"
                onChange={handleChange}
                name="city"
                value={city}
                placeholder="City"
              />
              <input
                type="number"
                name="pin"
                value={pin}
                onChange={handleChange}
                placeholder="PIN"
              />
            </div>
            <label>Line2</label>
            <div className={styles.address_cont}>
              <input
                type="text"
                name="state"
                onChange={handleChange}
                placeholder="State"
              />
              <input
                type="text"
                name="country"
                onChange={handleChange}
                placeholder="Country"
              />
            </div>

            <label>
              Card Number <span className={styles.mandetory_fileds}>*</span>
            </label>
            <input
              type="text"
              name="card_no"
              onChange={handleChange}
              placeholder="Enter your card Number"
            />

            <div className={styles.address_cont}>
              <input type="text" placeholder="CVV" />
              <input type="text" placeholder="card pin" />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "15px",
              }}
            >
              {" "}
              <button
                className={styles.register_BTN}
                type="submit"
                value="submit"
                onClick={handleclick}
              >
                Make Payment
              </button>
              <button
                className={styles.register_BTN}
                type="submit"
                value="cancel"
              >
                cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
